<template>
    <div class="sports-page">
        <div class="sports-bg">
            <div class="sports-bg-gradient"></div>
            <div class="sports-bg-grid"></div>
        </div>

        <div class="sports-card">
            <div class="sports-badge" aria-hidden="true">Coming soon</div>


            <h1 class="sports-title">Sports</h1>
            <p class="sports-desc">Live odds, in-play betting, and more are on the way. We’re building a sports experience you’ll love.</p>

            <router-link to="/" class="sports-cta">Back to home</router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SportsComingSoon',
    metaInfo: {
        title: 'Sports - Coming Soon'
    }
}
</script>

<style scoped>
.sports-page {
    min-height: calc(100vh - 80px);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem 1.5rem;
    position: relative;
    overflow: hidden;
}

.sports-bg {
    position: absolute;
    inset: 0;
    background: var(--bg-purple-dark);
}

.sports-bg-gradient {
    position: absolute;
    inset: 0;
    background: radial-gradient(ellipse 80% 60% at 50% 20%, rgba(44, 15, 99, 0.5) 0%, transparent 50%),
                radial-gradient(ellipse 60% 40% at 80% 80%, rgba(72, 58, 160, 0.2) 0%, transparent 50%);
    pointer-events: none;
}

.sports-bg-grid {
    position: absolute;
    inset: 0;
    background-image: linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px),
                      linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px);
    background-size: 48px 48px;
    pointer-events: none;
}

.sports-card {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 440px;
    text-align: center;
    padding: 2.5rem 2rem;
    background: rgba(21, 10, 46, 0.85);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 24px;
    backdrop-filter: blur(20px);
    box-shadow: 0 24px 48px rgba(0, 0, 0, 0.4);
    animation: cardIn 0.5s ease-out;
}

@keyframes cardIn {
    from {
        opacity: 0;
        transform: translateY(12px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.sports-badge {
    display: inline-block;
    padding: 0.35rem 0.85rem;
    margin-bottom: 1.5rem;
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--accent-yellow);
    background: rgba(212, 165, 116, 0.12);
    border: 1px solid rgba(212, 165, 116, 0.25);
    border-radius: 999px;
    animation: badgePulse 2s ease-in-out infinite;
}

@keyframes badgePulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.85; }
}

.sports-icon-wrap {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.5rem;
}

.sports-icon-bg {
    position: absolute;
    width: 88px;
    height: 88px;
    border-radius: 50%;
    background: linear-gradient(135deg, rgba(44, 15, 99, 0.6) 0%, rgba(72, 58, 160, 0.3) 100%);
    border: 1px solid rgba(255, 255, 255, 0.1);
}

.sports-icon {
    width: 48px;
    height: 48px;
    color: var(--accent-yellow);
    position: relative;
    z-index: 1;
}

.sports-title {
    font-size: 2rem;
    font-weight: 700;
    color: #fff;
    letter-spacing: -0.02em;
    margin: 0 0 0.75rem;
    line-height: 1.2;
}

.sports-desc {
    font-size: 0.9375rem;
    line-height: 1.55;
    color: rgba(255, 255, 255, 0.7);
    margin: 0 0 1.75rem;
    max-width: 320px;
    margin-left: auto;
    margin-right: auto;
}

.sports-cta {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 44px;
    padding: 0 1.5rem;
    font-size: 0.9375rem;
    font-weight: 600;
    color: #fff;
    background: var(--accent-btn-light-purple);
    border-radius: 12px;
    transition: background 0.2s, transform 0.15s;
}

.sports-cta:hover {
    background: #3a1580;
    transform: translateY(-1px);
}

@media (max-width: 480px) {
    .sports-card {
        padding: 2rem 1.5rem;
    }

    .sports-title {
        font-size: 1.75rem;
    }

    .sports-desc {
        font-size: 0.875rem;
    }
}
</style>
